/**
 * File: navigation-primary.js
 *
 * Helpers for the primary navigation.
 */
( function () {
	const subMenuParentItem = document.querySelectorAll(
			'.main-navigation .has-sub-menu'
		),
		topLevelLinks = document.querySelectorAll( '.top-level-link' );

	document.addEventListener( 'DOMContentLoaded', toggleFocusClass );

	/**
	 * Adds event listeners for tabbing in and out of parent items.
	 *
	 * @since January 31, 2020
	 * @author Corey Collins
	 */
	function toggleFocusClass() {
		subMenuParentItem.forEach( ( parentItem ) => {
			parentItem.addEventListener( 'focusin', toggleIn );
			parentItem.addEventListener( 'focusout', toggleOut );
		} );

		topLevelLinks.forEach( ( link ) => {
			link.addEventListener( 'mouseenter', ( e ) => {
				setActive( e );
			} );
		} );
	}

	/**
	 * Set the link to active to help keep the panel open.
	 *
	 * @param {Object} event The triggered event.
	 *
	 * @author Kelsey
	 */
	function setActive( event ) {
		topLevelLinks.forEach( ( parentItem ) => {
			parentItem.classList.remove( 'active' );
		} );
		event.target.classList.add( 'active' );
	}

	/**
	 * Handle toggling a parent menu on.
	 *
	 * @param {Object} event The triggered event.
	 *
	 * @since January 31, 2020
	 * @author Corey Collins
	 */
	function toggleIn( event ) {
		const parentMenuItems = getParents(
			event.target.parentNode,
			'.has-sub-menu'
		);
		parentMenuItems.forEach( ( parentItem ) => {
			parentItem.classList.add( 'focus' );
		} );
	}

	/**
	 * Handle toggling a parent menu off.
	 *
	 * @param {Object} event The triggered event.
	 *
	 * @since January 31, 2020
	 * @author Corey Collins
	 */
	function toggleOut( event ) {
		const parentMenuItems = getParents(
			event.target.parentNode,
			'.has-sub-menu'
		);
		parentMenuItems.forEach( ( parentItem ) => {
			parentItem.classList.remove( 'focus' );
		} );
	}

	// eslint-disable-next-line eslint-comments/disable-enable-pair
	/* eslint-disable func-style */
	/**
	 * Get all of the parents for a matching element and selector.
	 * https://gomakethings.com/climbing-up-and-down-the-dom-tree-with-vanilla-javascript/#getting-all-matches-up-the-tree
	 *
	 * @param {Object} elem     The parent menu item.
	 * @param {string} selector The CSS class of the element.
	 *
	 * @since January 31, 2020
	 * @author Corey Collins
	 *
	 * @return {Array} Parents.
	 */
	const getParents = function ( elem, selector ) {
		// Element.matches() polyfill.
		if ( ! Element.prototype.matches ) {
			Element.prototype.matches =
				Element.prototype.matchesSelector ||
				Element.prototype.mozMatchesSelector ||
				Element.prototype.msMatchesSelector ||
				Element.prototype.oMatchesSelector ||
				Element.prototype.webkitMatchesSelector ||
				function ( s ) {
					const matches = (
						this.document || this.ownerDocument
					).querySelectorAll( s );
					let i = matches.length;
					while ( 0 >= --i && matches.item( i ) !== this ) {}
					return -1 > i;
				};
		}

		// Setup parents array.
		const parents = [];

		// Get matching parent elements.
		for ( ; elem && elem !== document; elem = elem.parentNode ) {
			// Add matching parents to array.
			if ( selector ) {
				if ( elem.matches( selector ) ) {
					parents.push( elem );
				}
			} else {
				parents.push( elem );
			}
		}

		return parents;
	};
} )();

/**
 * Show/Hide the Search Form in the header.
 *
 * @author Corey Collins
 */

( function () {
	const siteHeaderAction = document.querySelector( '.search-trigger' );

	if ( ! siteHeaderAction ) {
		return;
	}

	const headerSearchToggle = document.querySelector(
			'.search-trigger .cta-button'
		),
		headerSearchForm = document.querySelector(
			'.site-search .form-container'
		);

	if ( ! headerSearchToggle || ! headerSearchForm ) {
		return;
	}

	headerSearchToggle.addEventListener( 'click', toggleSearchForm );
	document.body.addEventListener( 'keyup', hideSearchForm );
	document.body.addEventListener( 'touchstart', hideSearchForm );
	document.body.addEventListener( 'click', hideSearchForm );

	/**
	 * Check to see if the search is open or not.
	 *
	 * @since January 31, 2020
	 * @author Corey Collins
	 *
	 * @return {boolean} True if search is open, false if not.
	 */
	function searchIsOpen() {
		if ( document.body.classList.contains( 'search-form-visible' ) ) {
			return true;
		}

		return false;
	}

	/**
	 * Toggle our form display by changing body classes and aria labels.
	 *
	 * @since January 31, 2020
	 * @author Corey Collins
	 */
	function toggleSearchForm() {
		document.body.classList.toggle( 'search-form-visible' );

		toggleAriaLabels();
	}

	/**
	 * Toggle the aria label values.
	 *
	 * @since January 31, 2020
	 * @author Corey Collins
	 */
	function toggleAriaLabels() {
		if ( searchIsOpen() ) {
			headerSearchForm.setAttribute( 'aria-hidden', 'false' );
			headerSearchToggle.setAttribute( 'aria-expanded', 'true' );
		} else {
			headerSearchForm.setAttribute( 'aria-hidden', 'true' );
			headerSearchToggle.setAttribute( 'aria-expanded', 'false' );
		}
	}

	/**
	 * Hide the form if we click or tab outside of its container.
	 *
	 * @param {Object} event The targeted element.
	 *
	 * @since January 31, 2020
	 * @author Corey Collins
	 */
	function hideSearchForm( event ) {
		const isTargetInside = siteHeaderAction.contains( event.target );
		const isTargetInsideForm = headerSearchForm.contains( event.target );

		if ( ! isTargetInside ) {
			if ( ! isTargetInsideForm ) {
				document.body.classList.remove( 'search-form-visible' );
				toggleAriaLabels();
			}
		}
	}
} )();
